import { useCallback, useEffect, useState } from 'react';
import {
  type LandingLocale,
  landingMarketingCopy,
} from './landingMarketingCopy';

const STORAGE_KEY = 'landing-lng';

export function detectBrowserLandingLocale(): LandingLocale {
  if (typeof navigator === 'undefined') {
    return 'vi';
  }
  const candidates =
    navigator.languages?.length > 0 ? navigator.languages : [navigator.language];
  for (const raw of candidates) {
    const base = raw.toLowerCase().split('-')[0];
    if (base === 'vi') {
      return 'vi';
    }
    if (base === 'en') {
      return 'en';
    }
  }
  return 'vi';
}

function readStoredLandingLocale(): LandingLocale | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === 'vi' || value === 'en') {
      return value;
    }
  } catch {
    /* private mode / disabled storage */
  }
  return null;
}

export function useLandingLocale() {
  const [locale, setLocaleState] = useState<LandingLocale>(() =>
    readStoredLandingLocale() ?? detectBrowserLandingLocale(),
  );

  const setLocale = useCallback((next: LandingLocale) => {
    setLocaleState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      /* ignore */
    }
  }, []);

  const copy = landingMarketingCopy[locale];

  useEffect(() => {
    document.documentElement.lang = locale;
    document.title = copy.documentTitle;
  }, [locale, copy.documentTitle]);

  return { locale, setLocale, copy };
}
